import React, {ComponentType} from "react";
import BookingDialogHeader from "./index";
import {IContainerProps, IHandlers, IProps, IServices} from './types';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import {BookingType} from "app/app.types";

const NS = 'BookingDialogHeaderContainer';

const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IProps & IContainerProps & IHandlers & IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {
    isNewBooking, bookingMethod, booking, bookingState, canSave, isSaving, headerOverride,
    handleBookingUpdated, handleCheckForSave, isLoading, venueVisitedCount, averageSpendAmount, currency
  }: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  props.isNewBooking = isNewBooking;
  props.bookingMethod = bookingMethod;
  props.bookingState = bookingState;
  props.headerOverride = headerOverride;
  props.canSave = canSave;
  props.isSaving = isSaving;
  props.isLoading = isLoading;
  props.isLocked = booking ? booking.locked : false;
  props.bookingType = booking ? booking.bookingType : BookingType.Booking;
  props.venueVisitedCount = venueVisitedCount;
  props.averageSpendAmount = averageSpendAmount;
  props.currency = currency;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleCheckForSave,
    handleSetBookingMethod: (bookingMethod) => {
      booking.method = bookingMethod;
      handleBookingUpdated(booking);
    },
    handleToggleLocked: () => {
      booking.locked = !booking.locked;
      handleBookingUpdated(booking);
    }
  }

  return ReactUtilsService.containerWrap(
    <BookingDialogHeader {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ABookingDialogHeader: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
